import { createSelector } from 'reselect';
import { prop, defaultTo } from 'ramda';
import { parsePhoneNumber, PARSE_TYPE } from '../utils/normalizing';

export const getEligibility = prop('eligibility');

export const getFirstName = createSelector(getEligibility, prop('firstName'));

export const getLastName = createSelector(getEligibility, prop('lastName'));

export const getPlateNumber = createSelector(getEligibility, prop('plateNumber'));

export const getVinNumber = createSelector(getEligibility, prop('vinNumber'));

export const getPhoneNumber = createSelector(getEligibility, prop('phoneNumber'));

export const getPhoneCountry = createSelector(getEligibility, prop('phoneCountry'));

export const getNormalizedPhoneNumber = createSelector([getPhoneNumber, getPhoneCountry], (phoneNumber, phoneCountry) =>
  defaultTo('', parsePhoneNumber(phoneNumber, phoneCountry, PARSE_TYPE.INTERNATIONAL))
);

export const getBrand = createSelector(getEligibility, prop('brand'));

export const getCountry = createSelector(getEligibility, prop('country'));

export const getModel = createSelector(getEligibility, prop('model'));

export const getEnergy = createSelector(getEligibility, prop('energy'));

export const getEnergyType = createSelector(getEligibility, prop('energyType'));

export const getRegistrationDate = createSelector(getEligibility, prop('registrationDate'));

export const getType = createSelector(getEligibility, prop('type'));

export const getWeight = createSelector(getEligibility, prop('weight'));

export const getOtp = createSelector(getEligibility, prop('otp'));

export const getMileage = createSelector(getEligibility, prop('mileage'));

export const getLeaserContractNumber = createSelector(getEligibility, prop('leaserContractNumber'));
